import { RoundOut, Setting, UserDefault } from '@ucr/icons/main';

export const accountMenu = [
  {
    title: 'Профиль',
    icon: UserDefault,
    link: '/profile',
    disabled: true,
  },
  {
    title: 'Настройки',
    icon: Setting,
    link: '/settings',
    disabled: true,
  },
  {
    title: 'Выход',
    icon: RoundOut,
    link: '/logout',
    disabled: false,
  },
];
